package one.healthium.meal_plans.di

import kotlinx.serialization.json.Json
import one.healthium.meal_plans.data.AppMealPlanRepository
import one.healthium.meal_plans.data.MealPlanMapper
import one.healthium.meal_plans.data.MealPlansApiClient
import one.healthium.meal_plans.domain.MealPlanRepository
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val mealPlansDataModule = module {
    single {
        val json = Json {
            ignoreUnknownKeys = true
            isLenient = true
        }
        val baseHttpClient = MealPlansApiClient.createBaseHttpClient(json)
        MealPlansApiClient.factory(baseHttpClient, get())
    }

    singleOf(::AppMealPlanRepository) bind MealPlanRepository::class

    factoryOf(::MealPlanMapper)
}